import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'language'
})
export class LanguagePipe implements PipeTransform {

  transform(value: string = '', lang: 'en' | 'sw' = 'sw'): string {
    if (lang === 'en') {
      return value?.match(/\[en](.*?)\[\/en]/)?.[1] || value?.match(/\[EN](.*?)\[\/EN]/)?.[1] || ''
    } else {
      return value?.match(/\[sw](.*?)\[\/sw]/)?.[1] || value?.match(/\[SW](.*?)\[\/SW]/)?.[1] || value
    }
  }
}
